<dbw-investor-viewer-accordion
  anchorId="investor-viewer-consultants"
  accordionTitle="Affectation consultant"
  [itemsCount]="assignments().length"
  [expanded]="true">
  @if (assignments().length === 0) {
    <div class="empty-state">Aucune affectation consultant disponible.</div>
  } @else {
    <oui-table class="data-table" [lineSizing]="'dense'">
      <table mat-table [dataSource]="assignments()">
        <ng-container matColumnDef="relation">
          <th mat-header-cell *matHeaderCellDef>Relation</th>
          <td mat-cell *matCellDef="let row">
            <dbw-consultant-relation-tag
              [relationTypeCode]="row.investorRelationTypeCode"
            ></dbw-consultant-relation-tag>
          </td>
        </ng-container>
        <ng-container matColumnDef="consultant">
          <th mat-header-cell *matHeaderCellDef>Consultant</th>
          <td mat-cell *matCellDef="let row">
            <dbw-consultant-card
              [id]="row.consultantId"
              [code]="formatText(row.consultantCode)"
              [name]="formatText(row.consultantName)"
              [statusCode]="row.consultantStatusCode"
            ></dbw-consultant-card>
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let row">{{ formatText(row.email) }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Statut</th>
          <td mat-cell *matCellDef="let row">
            <oui-tag type="status" size="big" [status]="row.isActive ? 'completed' : 'pending'">
              {{ row.isActive ? "Active" : "Inactive" }}
            </oui-tag>
          </td>
        </ng-container>
        <ng-container matColumnDef="dates">
          <th mat-header-cell *matHeaderCellDef>Dates</th>
          <td mat-cell *matCellDef="let row">
            <div class="content-short">
              <div>Activation: {{ formatDate(row.activationDate) }}</div>
              <div>Désactivation: {{ formatDate(row.deactivationDate) }}</div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="identifiers">
          <th mat-header-cell *matHeaderCellDef>Identifiants</th>
          <td mat-cell *matCellDef="let row">
            <div class="content-long">
              <div>AssignmentId: {{ row.assignmentId }}</div>
              <div>ArianeId: {{ formatText(row.arianeId) }}</div>
              <div>IdSource: {{ formatText(row.sourceId) }}</div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="consultantColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: consultantColumns"></tr>
      </table>
    </oui-table>
  }
</dbw-investor-viewer-accordion>
